import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axiosConfig";
import "../styles/LOADEvoHQLogin.css";

export default function LOADEvoHQLogin() {
  const navigate = useNavigate();

  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const email = userEmail.trim();

    if (!email || !userPassword) {
      setMessage("❌ Email and password are required.");
      return;
    }

    try {
      setLoading(true);

      // axiosConfig normalmente já tem baseURL com /api
      const { data } = await axios.post("/loadevoghq/login", {
        userEmail: email,
        userPassword,
      });

      if (!data?.ok || !data?.user) {
        setMessage("❌ Login failed.");
        return;
      }

      // sessão simples (sem JWT)
      localStorage.setItem("loadevoghqUser", JSON.stringify(data.user));

      // ✅ redirect to the other project dashboard
      window.location.assign("http://127.0.0.1:5180/");
    } catch (err) {
      const apiMsg = err?.response?.data?.message;
      setMessage(apiMsg ? `❌ ${apiMsg}` : "❌ Server error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loadevoghq-login-page">
      {/* Futuristic animated background layers */}
      <div className="loadevoghq-bg">
        <div className="loadevoghq-bg-orb loadevoghq-bg-orb--a" />
        <div className="loadevoghq-bg-orb loadevoghq-bg-orb--b" />
        <div className="loadevoghq-bg-orb loadevoghq-bg-orb--c" />
        <div className="loadevoghq-bg-grid" />
        <div className="loadevoghq-bg-scanlines" />
      </div>

      <div className="loadevoghq-login-shell">
        <div className="loadevoghq-login-card">
          {/* Animated border ring */}
          <div className="loadevoghq-login-card-border" aria-hidden="true" />

          <div className="loadevoghq-login-header">
            <div className="loadevoghq-login-badge">
              <span className="loadevoghq-login-badge-dot" />
              <span className="loadevoghq-login-badge-text">HQ ACCESS</span>
            </div>

            <h1 className="loadevoghq-login-title">LOADEvo HQ</h1>
            <p className="loadevoghq-login-subtitle">
              Secure console — authenticate to continue
            </p>
          </div>

          {message && <div className="loadevoghq-login-message">{message}</div>}

          <form onSubmit={handleSubmit} className="loadevoghq-login-form">
            <div className="loadevoghq-field">
              <label className="loadevoghq-login-label">Email</label>
              <div className="loadevoghq-input-wrap">
                <span className="loadevoghq-input-icon" aria-hidden="true">✦</span>
                <input
                  className="loadevoghq-login-input loadevoghq-login-input--withIcon"
                  type="email"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  placeholder="name@company.com"
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="loadevoghq-field">
              <label className="loadevoghq-login-label">Password</label>

              <div className="loadevoghq-input-wrap">
                <span className="loadevoghq-input-icon" aria-hidden="true">⌁</span>
                <input
                  className="loadevoghq-login-input loadevoghq-login-input--withIcon"
                  type={showPassword ? "text" : "password"}
                  value={userPassword}
                  onChange={(e) => setUserPassword(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="loadevoghq-login-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <button className="loadevoghq-login-btn" type="submit" disabled={loading}>
              <span className="loadevoghq-btn-glow" aria-hidden="true" />
              <span className="loadevoghq-btn-text">
                {loading ? "Signing in..." : "Sign in"}
              </span>
              <span className="loadevoghq-btn-spark" aria-hidden="true">⟡</span>
            </button>

            <div className="loadevoghq-login-footer">
              <span className="loadevoghq-login-footer-chip">Encrypted channel</span>
              <span className="loadevoghq-login-footer-chip">Audit logged</span>
              <span className="loadevoghq-login-footer-chip">Restricted</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
